import { ElementAttribute } from "./ElementAttribute";
import { ElementType } from "./ElementType";

export class SimpleDownload
{
  static downloadData( filename:string, dataURL:string )
  {
    let anchorElement = ElementType.anchor.create();

    ElementAttribute.href.to( anchorElement, dataURL );
    ElementAttribute.download.to( anchorElement, filename );
    
    if ( document.createEvent ) 
    {
      var event = document.createEvent( "MouseEvents" );
      event.initEvent( "click", true, true );
      anchorElement.dispatchEvent( event );
    }
    else 
    {
      anchorElement.click();
    }
  }

  static downloadCanvas( filename:string, canvas:HTMLCanvasElement )
  {    
    SimpleDownload.downloadData( filename, canvas.toDataURL( "image/png" ) );
  } 

  static downloadUTF8( filename:string, text:string ) 
  {
    SimpleDownload.downloadData( filename, "data:text/plain;charset=utf-8," + encodeURIComponent( text ) );    
  }

}